import { IconsProps } from '@/types/shared'

const UsageTrendIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chart-bar-decreasing-icon lucide-chart-bar-decreasing"
            >
                <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                <path d="M7 11h8" />
                <path d="M7 16h3" />
                <path d="M7 6h12" />
            </svg>
        </div>
    )
}

export default UsageTrendIcons
